<template>
  <div class="app_first">
    <!-- 过滤栏 组件-->
    <!--<div>-->
    <!-- 本周(按钮) -->
    <div style="margin: 15px 5px">
      <button class="el-icon-arrow-left btn" @click="getPrevWeek"></button>
      <span class="week" v-text="weekText"></span>
      <button class="el-icon-arrow-right btn" @click="getNextWeek"></button>
    </div>

    <!-- 表单 组件-->
    <div class="table1">
      <table border="1 solid" cellspacing="0">
        <tr style="background-color:#f2f2f2;height: 50px;color: #a4a7af">
          <td v-for="(item,index) in arr" :key="index">
            <span>{{item}}</span>
          </td>
        </tr>
        <tr style="background-color: #f2f2f2;height: 30px;color: #a4a7af">
          <td v-for="(item,index) in dayNames" :key="index">
            <span>{{item}}</span>
            <br>
          </td>
        </tr>
        <tr class="td_65px">
          <!-- <td v-for="item in items">
                        {{item.text}}
          </td>-->
          <td v-for="(item,week_index) in items" :key="week_index" width="10%">
            <span v-for="(item1,index) in item.todos" :key="index">
              <br>
              {{ item1.doctor_selected }}
              <br>
              {{ item1.startTime }}
              {{ item1.endTime}}
              <br>
			  {{ item1.schedule_plan_name }}
              <br>
            </span>
          </td>
        </tr>
      </table>
      <!-- 底部三个按钮 -->
      <div class="btns">
        <el-button type="primary" @click="edit">编辑排班</el-button>

        <!--<el-button type="success" @click="conventionList">-->
        <!--生成预约列表-->
        <!--</el-button>-->
      </div>
    </div>
  </div>
</template>
<style  type="text/css" scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }
body {
  background: white;
}
.app_first p {
  color: #c2c2c2;
  font-size: 14px;
}

.app_first .btn {
  border-radius: 100%;
  background: #ffffff;
  width: 30px;
  height: 30px;
  box-shadow: 1px 1px 5px #888888;
  border: #ebebeb;
  color: #b4b4b4;
  margin-left: 16px;
  float: left;
}

.app_first .week {
  background: #ffffff;
  color: #a1a1a3;
  width: 100px;
  height: 30px;
  display: block;
  padding-top: 5px;
  text-align: center;
  float: left;
  margin-left: 16px;
  margin-top: -3px;
}

.app_first .block_small {
  width: 120px;
}

.app_first .table1 {
  padding-bottom: 100px;
  position: absolute;
  margin-top: 50px;
  background: #ffffff;
  width: 87%;
}

.app_first table {
  clear: left;
  border-color: rgba(255, 255, 255, 0.5);
  background: #ffffff;
  text-align: center;
  width: 98%;
  margin-left: 18px;
}

.app_first .td_65px {
  height: 300px;
  opacity: 0.7;
}

.app_first .btns {
  margin-left: 42%;
  margin-top: 30px;
}

.app_first .btn_foot {
  margin-left: 18px;
  border: none;
  width: 80px;
  height: 30px;
  background: #f4f4f4;
}

.app_first .btn_add {
  background: green;
  color: #ffffff;
}
</style>
<script>
var myDate = new Date();

export default {
  data() {
    return {
      weekText: "本周",
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      todayTime_value: Date.now(),
      year: myDate.getFullYear(),
      month: myDate.getMonth() + 1,
      day: myDate.getDate(),

      //获取今天是星期几(0-6 0代表星期天)
      which_weekDay: myDate.getDay(),
      dayNames: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日"
      ],
      datelist: [],

      // 所有科室
      type_options: [
        {
          type_value: "选项1",
          type_label: "普通门诊"
        },
        {
          type_value: "选项2",
          type_label: "专家门诊"
        }
      ],
      type_value: "普通门诊",
      //所有人

      items: [
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              guahao_type: "",
              selectTime: "",
              active: false,
              findIndex_active: false,
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              guahao_type: "",
              selectTime: "",
              active: false,
              findIndex_active: false,
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              guahao_type: "",
              selectTime: "",
              active: false,
              findIndex_active: false,
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              guahao_type: "",
              selectTime: "",
              active: false,
              findIndex_active: false,
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              guahao_type: "",
              selectTime: "",
              active: false,
              findIndex_active: false,
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              guahao_type: "",
              selectTime: "",
              active: false,
              findIndex_active: false,
              date: "",
              doctor_id: ""
            }
          ]
        },
        {
          todos: [
            {
              scheduling_id: "",
              doctor_selected: "暂无排班",
              time_start: "",
              time_end: "",
              guahao_type: "",
              selectTime: "",
              active: false,
              findIndex_active: false,
              date: "",
              doctor_id: ""
            }
          ]
        }
      ],

      arr: [],
      datenum: 0
    };
  },
  mounted: function() {
    this.getDate();
    this.getinfo();
  },
  methods: {
    getinfo: function() {
      var startDate = {
        startDate: this.arr[0],
        endDate: this.arr[6]
      };
      this.$axios({
        url: "/api/schedule/getinfos",
        method: "GET",
        params: startDate
      })
        .then(su => {
          for (var k = 0; k < su.data.length; k++) {
            if (su.data[k].todos.length === 0) {
              this.items[k].todos = [
                {
                  scheduling_id: "",
                  doctor_selected: "暂无排班",
                  time_start: "",
                  time_end: "",
                  guahao_type: "",
                  selectTime: "",
                  active: false,
                  findIndex_active: false,
                  date: "",
                  doctor_id: ""
                }
              ];
            } else {
              this.items[k].todos = su.data[k].todos;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    getDate: function() {
      let a = Number(new Date()) + this.datenum * 8.64e7 * 7;
      let b = new Date(a);
      function getMonDate() {
        var d = b,
          day = d.getDay(), //获取周几
          date = d.getDate(); //获取日期
        if (day == 1) return d;
        if (day == 0) d.setDate(date - 6);
        //获取一个月的某一天
        else d.setDate(date - day + 1);
        return d;
      }
      function addZero(v) {  // 补零
        return v < 10 ? '0'+v : v
      }
      // d是当前星期一的日期对象
      let d = getMonDate();
      let m = d.getMonth() + 1;
      let dayArr = [];      // 日
      let yueArr = [];      // 月
      let dateStrArr = [];  // 日期数据 yyyy-mm-dd
      if (m < 10) {
        m = "0" + m;
      }
      for (var i = 0; i < 7; i++) {         // 注入天数
        let day = d.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        dayArr.push(day);
        yueArr.push(m);
        let dateStr = d.getFullYear().toString() + '-' + addZero(d.getMonth() + 1) + '-' + addZero(d.getDate());
        dateStrArr.push(dateStr);
        d.setDate(d.getDate() + 1);
      }
      let yindex;
      let leen;
      for(let i=0;i<dayArr.length;i++){       // 修改月份数据
        let a = dayArr[i];
        let b = dayArr[i+1];
        if(parseInt(a) > parseInt(b)){
          let len = (dayArr.length) - i - 1;
          leen = len;
          yueArr.splice(i,len);
        }
      }
      let showy = parseInt(m)+1;
      if(showy > 12){
        showy = 1;
      }
      if(showy < 10){
        showy = '0' + showy;
      }
      for(let j=0;j<leen;j++){
        yueArr.push(showy);
      }
      for(var i = 0; i < 7; i++){
        // this.arr.push(d.getFullYear() + "-" + yueArr[i] + "-" + dayArr[i]);
        this.arr.push(dateStrArr[i]);
      }
    },
    //上周
    getPrevWeek: function() {
      this.datenum--;
      if (this.datenum < 0) {
        this.weekText = "上周";
      } else if (this.datenum == 0) {
        this.weekText = "本周";
      }
      this.arr = [];
      this.getDate();
      this.getinfo();
    },

    //下周
    getNextWeek: function() {
      this.datenum++;
      if (this.datenum > 0) {
        this.weekText = "下周";
      } else if (this.datenum == 0) {
        this.weekText = "本周";
      }
      this.arr = [];
      this.getDate();
      this.getinfo();
    },
    //编辑排班
    edit: function() {
      if (this.datenum >= 0) {
        let obj = JSON.stringify(this.arr);
        this.$router.push({ path: "./new_add_work", query: { obj: obj } });
      } else {
        this.$message({
          type: "warning",
          message: "历史排班不可编辑"
        });
      }
    },
    getinfo2: function() {
      let startDate = {
        startDate: this.arr[0],
        endDate: this.arr[6]
      };
      this.$axios({
        url: "/api/schedule/toreservation",
        method: "GET",
        params: startDate
      })
        .then(res => {
        })
        .catch(err => {
          console.log(err.data);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// arrange.vue?e9ef8d12